export default "__VITE_ASSET__f55e8002__"